import { sponsorAxiosInstance } from './base-service';

export const GetOktUserToken = async () => {
  const path = 'v1/sponsor/login/Okta';
  const res = await sponsorAxiosInstance.get(path, {});
  return res;
};
